<template>
  <div>
    <ob-collapse :type="10" :expand="true">
      <h4 class="h4_design" style=" font-weight: 600; color:#475259;font-size:13.5px;" slot="collapse-title">
        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_comments.svg`" style="padding-right:8px;"/>
          Comments
      </h4>
      <div slot="collapse-icon-custom" class="collapse-icon-custom" v-if="showPreviusComment()">
        <div style="font-size: 12px;font-weight: bold;display: block;" @click.stop="addPreviousComment">
          <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`"/>
          <span style="color:#464444;font-weight: 600;">
            Add Previous comments
          </span>
        </div>
      </div>
      <div slot="collapse-details">
        <template>
          <ob-textarea :maxLength="1200" :height="'70px'" placeholder="Enter Comments " v-model.trim="Content"></ob-textarea>
          <ob-button style="margin-bottom: 10px;margin-top: 8px;" type="primary"  :disabled="Content == ''" @click="saveComment">Save</ob-button>
        </template>
        <template  v-for="(item, index) in CommentList" >
          <table width="100%" style="margin-bottom: 15px;">
            <tr>
              <td rowspan="2" style="vertical-align: top;padding-right: 10px;width: 5%;"><img  :src='item.ProfilePicLink' style="width:30px;border-radius:50%;margin-left:10px;"></td>
              <td style="padding-bottom: 5px;">
                <div class="user-name">
                  <span style="color: #4A90E2;font-weight: bold;">{{item.CreatedBy}}</span>
                  <span style="color: block;font-size: 11px; padding-left: 20px;">{{item.CreatedDate}}</span>
                </div>
                <div v-if="showActions(index)" id="actions">
                  <div class="actions" v-if="!CommentList[index].isEdit">
                    <span style="color:  #4A90E2;font-size: 10px;  cursor: pointer;" @click="CommentList[index].isEdit = true">Edit</span> | <span  @click="confirmdeleteComment(item.Id , index)" style="color: #DD3D64;font-size: 10px; cursor: pointer;" >Delete</span>
                  </div>
                  <div class="actions" v-else>
                    <span style="color:  #4A90E2;font-size: 10px; cursor: pointer;" :class=" (item.Content != null && item.Content != '') ? '':'cursorCls'" @click="editSaveComment(index,item)">Save</span> | <span  @click="onCancel(index,item)" style="color: #DD3D64;font-size: 10px; cursor: pointer;">Cancel</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <p v-if="!CommentList[index].isEdit" style="font-weight:700;word-break: break-word;text-align: left;white-space: pre-line;">
                  {{item.Content}}
                </p>
                <ob-textarea v-else :height="'70px'" :maxLength="1200" placeholder="Enter Comments " v-model.trim="item.Content"></ob-textarea>
              </td>
            </tr>
          </table>
        </template>
      </div>
    </ob-collapse>
    <add-previous-comment v-if="openCommentsPopup" :openModal.sync="openCommentsPopup"  :content="content"></add-previous-comment>
  </div>
</template>

<script>
import AddPreviousComment from './AddPreviousComment.vue'
export default {
  props: ["content","Comments","loadComments"],
  data() {
    return {
      openCommentsPopup:false,
      editDescription:'',
      CreatedBy:'',
      CreatedDate:'',
      Content:'',
      CommentList:[],
      clonedContent:null
    }
  },
  components: {
    "add-previous-comment":AddPreviousComment
  },
  computed: {
  },
  created() {
    this.CommentList = this.Comments
  },
  watch: {
    Comments(val)
    {
      this.CommentList = val
    }
  },
  methods: {
     showPreviusComment()
     {
        var now = moment();
        var then = moment(this.content.CreatedDate);
        if (now > then) {
           return true
        } else {
          return false
        }
     },
      guid() {
      function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
          s4() + '-' + s4() + s4() + s4();
      },

      showActions(index)
      {
        let from = this.$route.query.from
        if(this.CommentList.length > 0)
          if(from == 'ReportingEmployee')
            return true
          else{
            return ((this.CommentList[index].commentByMail == this.loggedInUserObj.email))
          }
      },
      saveComment() {
        var comment =
        {
          "Title": this.Content,
          "Type" :3
        }
        this.$parent.$parent.commanServiceForUpdate(comment)
        this.Content = ''
        },
        onCancel(index,item){
          this.CommentList[index].isEdit = false;
          this.CommentList[index].Content = this.content.Comments[index].Content ;
        },
        editSaveComment(index,item)
        {
           if(item.Content != null && item.Content != '')
           {
              var comment =
              {
                   ResourceId : item.Id,
                   "Comment":item.Content,
                   "TaskId" :this.content.TaskId
              }
              this.$loading({loadingText: 'Please wait...'});
              var Id = this.$route.params.id
              ajax.put(`/Task/UpdateComment`, comment, res => {
              if (res.data.State == true) {
                  //local
                    this.CommentList[index].Content = item.Content
                  this.CommentList[index].isEdit = false
                  this.content.Comments[index].Content = item.Content
                  this.$loading({}).close();
              }
              else{
                  this.$message({
                          type: 'error',
                          message: res.data.Message
                  });
              }
          });
        }
        },
      confirmdeleteComment(id , index)
      {
      this.selectedIndex = index
      this.$alert2("Are you sure you want to delete ?", "Alert", {
          type: "confirm",
          yesButtonText: "Yes",
          noButtonText: "No",
          callback: (action) => {
          if(action === true) {
              var deleteObject = {
                      Type : 3,
                      TaskId : this.content.TaskId,
                      ResourceId : id
                  }
          this.$parent.$parent.deleteResource(deleteObject)
          }
          }
      });
      },
      deleteComment()
      {
          var id = this.CommentList[this.selectedIndex].Id
          this.CommentList.splice(this.selectedIndex, 1);

          var index = this.content.Comments.findIndex(x => x.Id == id);
          this.content.Comments.splice(index, 1);
          this.$message({
                          type: "success",
                          message: ResourceCore.Messages["Comment_Deleted"]
          });
      },
      addPreviousComment(){
        this.openCommentsPopup = true
      }

  }
}
</script>

<style lang="scss" scoped>
  .img-responsive {
      border-radius: 100%;
      width: 30px;
  }

  .user-name {
      float: left;
  }

  .actions {
      font-weight: bold;
      float: right;
  }

  .profile-img {
      display: inline-block;
      width: 10%;
  }

  .comment-section {
      margin-left: -35px;
      display: inline-block;
      width: 92%;
  }
  .td{
      padding:2px;
  }
  table #actions {
  display: none;
  }

  table:hover #actions {
  display: block;
  }
  .cursorCls{
    cursor:not-allowed !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/Comments.vue